import * as moment from 'moment-timezone';

/** Día pasado de la gráfica «Inventario proyectado»: cierre y pipas de ese día. */
export interface ProjectionPastDay {
  label: string;
  value: number | null;
  offset: number;
  arrived: number | null;
  inProcess: number | null;
  prevWeek: boolean;
}

/** Días pasados de una fila del review más las pipas de hoy, en la forma que pide ProjectionRow. */
export interface ProjectionPast {
  past: ProjectionPastDay[];
  todayArrived: number | null;
  todayInProcess: number | null;
}

/**
 * Días pasados (semana anterior + lo que va de esta, sin hoy) de una fila del review de
 * /inventory_managment, con los MISMOS campos que lee Análisis de Pedido: cierre (`stock_yesterday`,
 * `stock_past_yesterday`, `past_stock_N`), pipa que llegó (`past_purchase_N`) y pipa sin entrega
 * confirmada (`past_inprocess_N`). Sirve para que la gráfica abierta desde Sugerencias tenga el mismo
 * botón «Semana anterior» que la de Análisis de Pedido (Edey 20-oct).
 * `dayLabel` arma el rótulo de cada día (dow y fecha corta, como el resto del portal).
 */
export function projectionPast(row: any, dayLabel: (d: moment.Moment) => { dow: string; name: string }, today = moment().startOf('day')): ProjectionPast {
  const num = (v: any): number | null => (v != null && v !== '' ? +v : null);
  const pipe = (v: any): number | null => (v ? +v : null);
  const thisMonday = today.clone().startOf('isoWeek');
  const past: ProjectionPastDay[] = [];
  for (const d = thisMonday.clone().subtract(1, 'week'); d.isBefore(today, 'day'); d.add(1, 'day')) {
    const offset = today.diff(d, 'days');
    const close = offset === 1 ? row?.stock_yesterday : offset === 2 ? row?.stock_past_yesterday : row?.['past_stock_' + offset];
    const label = dayLabel(d.clone());
    past.push({
      label: `${offset === 1 ? 'Ayer' : offset === 2 ? 'Antier' : label.dow}<br>${label.name}`,
      value: num(close),
      offset,
      arrived: pipe(row?.['past_purchase_' + offset]),
      inProcess: pipe(row?.['past_inprocess_' + offset]),
      prevWeek: d.isBefore(thisMonday, 'day'),
    });
  }
  return { past, todayArrived: pipe(row?.past_purchase_0), todayInProcess: pipe(row?.past_inprocess_0) };
}
